import axios from "../../axios";

const getInventoryPricing = async (brand_name) => {
  try {
    const { data } = await axios.get(`/inventory_pricing/brand/${brand_name}`);
    return data;
  } catch (e) {
    return null;
  }
};

export {
  getInventoryPricing
}